import type { EmployeeResponse } from 'api/__GENERATED';
import { apiUtility, domainUtility } from 'utility';

import { toEmployee } from './toEmployee';

// Builds a normalized `Data.Employee` domain from a list of Employee DTOs.
function toEmployeeDomain(args: { dtos: EmployeeResponse[] }) {
  const { dtos } = args;

  const employeeDomain: NormalizedDomain<Data.Employee> = {
    allIds: [],
    byId: {},
  };

  apiUtility.iterator({
    list: dtos,
    transformer: (item) => {
      const employee = toEmployee(item);
      domainUtility.mutateAdd(employeeDomain, employee);
    },
  });

  return { employeeDomain };
}

export { toEmployeeDomain };
